/**
 * Depth — standard z-order layers for consistent rendering across scenes.
 *
 * Higher values render on top. All scenes should reference these constants
 * instead of using magic numbers.
 */

export const Depth = {
  /** Backgrounds, tilemaps */
  BACKGROUND: 0,

  /** Characters, enemies, projectiles */
  GAME: 10,

  /** Floating text, particles, attack animations */
  EFFECTS: 100,

  /** HP bars, word preview, action buttons */
  HUD: 200,

  /** Fullscreen blocker behind overlay content */
  OVERLAY: 500,

  /** Victory/defeat panels, dialog content */
  OVERLAY_CONTENT: 501,

  /** Framework-level UI (debug, system) */
  SYSTEM: 1000,
} as const;

export type DepthLayer = (typeof Depth)[keyof typeof Depth];
